import { RefObject, useEffect } from 'react';

import { rotatePoint } from '@/utils';

import { OcrItem } from './useOcrTree';

export const useDrawBoxes = (
  canvasRef: RefObject<HTMLCanvasElement | null>,
  ocrItems?: OcrItem[],
  rotation: number = 0,
  canvasVersion: number = 0
) => {
  useEffect(() => {
    let frameId: number | null = null;

    if (frameId != null) cancelAnimationFrame(frameId);

    frameId = requestAnimationFrame(() => {
      if (!canvasVersion || !ocrItems) return;

      const canvas = canvasRef.current;
      if (!canvas) return;

      const context = canvas?.getContext('2d', { willReadFrequently: true });
      if (!context) return;

      const dpr = window.devicePixelRatio || 1;
      const width = Math.round(canvas.width / dpr);
      const height = Math.round(canvas.height / dpr);

      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      context.clearRect(0, 0, width, height);

      const rotatedItems = ocrItems.map((item) => ({
        ...item,
        polygon: item.polygon.map((p) => {
          return rotatePoint({ x: p[0], y: p[1] }, rotation);
        }),
      }));

      for (const item of rotatedItems) {
        context.fillStyle = '#32B5FF33';
        context.beginPath();

        for (const [i, point] of item.polygon.entries()) {
          if (i === 0) {
            context.moveTo(point.x * width, point.y * height);
          } else {
            context.lineTo(point.x * width, point.y * height);
          }
        }

        context.closePath();
        context.fill();
      }
    });

    return () => {
      if (frameId != null) cancelAnimationFrame(frameId);
    };
  }, [canvasRef, rotation, ocrItems, canvasVersion]);
};
